import { render } from "./Spinner.vue?vue&type=template&id=2ce88276&ts=true"
import script from "./Spinner.vue?vue&type=script&lang=ts"
export * from "./Spinner.vue?vue&type=script&lang=ts"

import "./Spinner.vue?vue&type=style&index=0&id=2ce88276&lang=css"

import exportComponent from "/home/hugo/Proyectos/TierraMedia2.0/edoras/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__